import { createMuiTheme } from '@material-ui/core';
import { BREAKPOINTS, BUTTON_VARIANTS, PALETTES, TYPOGRAPHY } from './themeConstants';

/**
 * @type {import('@mui/material/styles').Components}
 */
const createComponents = palette => ({
    MuiContainer: {
        styleOverrides: {
            root: {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            },
        },
    },
    MuiButton: {
        styleOverrides: {
            root: {
                padding: '0.44rem 2rem',
                color: palette?.button?.contained?.textColor,
                backgroundColor: palette?.button?.contained?.background,
                '&:hover': {
                    backgroundColor: palette?.button?.contained?.backgroundHover,
                    color: palette?.button?.contained?.textHoverColor,
                },
            },
        },
        variants: BUTTON_VARIANTS,
    },
    MuiCssBaseline: {
        styleOverrides: {
            body: {
                backgroundColor: palette.backgroundColor,
            },
            a: {
                color: palette.textColor3,
                textDecoration: 'none',
                cursor: 'pointer',
                '&:hover': {
                    textDecoration: 'underline',
                },
            },
        },
    },
});

/**
 *
 * @param {*} palette - Selected Palette
 * @function getTheme - Function to get theme for selected palette
 * @returns {import('@mui/material').Theme} -Returns theme
 */
export const getTheme = palette => {
    let paletteConfig;
    if (palette === 'palette1') {
        paletteConfig = PALETTES?.palette1;
    } else if (palette === 'palette2') {
        paletteConfig = PALETTES?.palette2;
    } else if (palette === 'palette3') {
        paletteConfig = PALETTES?.palette3;
    } else if (palette === 'palette4') {
        paletteConfig = PALETTES?.palette4;
    } else if (palette === 'palette5') {
        paletteConfig = PALETTES?.palette5;
    } else {
        paletteConfig = PALETTES?.palette1;
    }
    return createMuiTheme({
        typography: TYPOGRAPHY,
        palette: paletteConfig,
        components: createComponents(paletteConfig),
        breakpoints: BREAKPOINTS,
    });
};
